import RightArrow from "../../../../images/ArrowRight.svg";
import {useNavigate} from "react-router-dom";
import useUrlParams from "../../../../customHooks/useUrlParams";
import {ProjectData} from "../masters/projects/queries/types";
import {CustomModal} from "../../../../utils/UtilFunctions";
import {ViewModalStylesAsset} from "../../../../styles/CustomModalStyles";
import {useState} from "react";

interface WorkProgressItemProps {
  res: ProjectData;
  index: number;
}

const WorkProgressItem = ({res, index}: WorkProgressItemProps) => {
  const navigate = useNavigate();
  const {customer_id} = useUrlParams();

  return (
    <div
      className="work-progress__block--grid"
      onClick={() =>
        navigate(`/${customer_id}/workprogress/${res.projectDetails.id}/view`)
      }
    >
      <div key={index}>{index + 1}. </div>
      <div className="work-progress__block--grid--mid">
        <b title={res.projectDetails.name} className="ellipsis-text">
          {res.projectDetails.name}
        </b>
        <span>{res.projectDetails.supplierName.desc}</span>

        <>
          <div className="work-progress__block--flex">
            <label>Last Updated Date</label>
            <b>:Today</b>
          </div>
        </>
      </div>
      <img src={RightArrow} alt="" />
    </div>
  );
};

export default WorkProgressItem;
